import { useState, useEffect } from 'react';
import { alertService } from '../services/alertService';

export const useRealtimeAlerts = () => {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isLive, setIsLive] = useState(false);

  const fetchAlerts = async () => {
    try {
      setIsLive(true);
      const data = await alertService?.getAllAlerts();
      setAlerts(data || []);
      setError(null);
    } catch (err) {
      console.error('Error fetching alerts:', err);
      setError(err?.message || 'Failed to fetch alerts');
    } finally {
      setLoading(false);
      setIsLive(false);
    }
  };

  useEffect(() => {
    fetchAlerts();

    // Refresh alerts every 2 minutes
    const interval = setInterval(() => {
      fetchAlerts();
    }, 120000);

    return () => clearInterval(interval);
  }, []);

  return {
    alerts,
    loading,
    error,
    isLive,
    refetch: fetchAlerts
  };
};